/* tslint:disable no-bitwise */
import { publish, subscribe, unsubscribe } from '@wh/message-bus'; // @ts-ignore

var requestCounter = 0;
export function generateMessageId() {
  requestCounter = requestCounter + 1 & 0xfff;
  var requestId = ((Date.now() & 0x7ffff) << 12 | requestCounter).toString(16);
  return requestId;
}
export function publishMessage(topic, data, id) {
  var headers = id ? {
    correlationId: id
  } : undefined;
  return publish({
    topic: topic,
    data: data,
    headers: headers
  });
}
export function subscribeToMessage(topic, _callback, requestId) {
  return subscribe({
    topic: topic,
    callback: function callback(message) {
      var data = message.data,
          headers = message.headers;

      if (!requestId || requestId === headers.correlationId) {
        _callback(data || {}, headers.correlationId);
      }
    }
  });
}
export function unsubscribeFromMessage(id) {
  unsubscribe(id);
}
//# sourceMappingURL=message.js.map